import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isOwnerHoldingWeeksPath = isSamePath(Path.OwnerHoldingWeeks)
